import Vue from "vue";
import VueRouter from "vue-router";

// const Index = () => import("../view/index.vue");
const Detail = () => import("../view/detail.vue");
const Search = () => import("../view/search.vue");
const Special = () => import("../view/special.vue");
const Channe = () => import("../view/channe.vue");
const Live = () => import("../view/live.vue");
const Dzck = () => import("../view/dzck.vue");
const Temp = () => import("../view/temp.vue");
const SmsPlan = () => import("../view/SmsPlan.vue");
const NotFound = () => import("../view/notFound.vue");

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  // base:"/",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("../view/index.vue"),
      meta: { title: "四川手机报" },
    },
    {
      path: "/channe/:id",
      name: "channe",
      component: Channe,
      meta: { title: "四川手机报" },
    },
    {
      path: "/news/:id/:topicid?",
      name: "news",
      component: Detail,
    },
    {
      path: "/detail/:id",
      redirect: (to) => ({ name: "news", params: { id: to.params.id } }),
    },
    {
      path: "/search/:keys",
      name: "search",
      component: Search,
      meta: { title: "搜索 - 四川手机报" },
    },
    {
      path: "/topic/:id",
      name: "topic",
      component: Special,
      meta: { title: "专题 - 四川手机报" },
    },
    {
      path: "/topic/:id",
      redirect: (to) => ({ name: "topic", params: { id: to.params.id } }),
    },
    {
      path: "/live/:id",
      name: "live",
      component: Live,
      meta: { title: "直播 - 四川手机报" },
    },
    {
      path: "/dzck",
      name: "dzck",
      component: Dzck,
      meta: { title: "四川手机报" },
    },
    {
      path: "/other/smsplan",
      name: "smsplan",
      component: SmsPlan,
    },
    {
      path: "/temp/:key",
      name: "temp",
      component: Temp,
      props: (route) => ({
        tempKey: String(route.params.key ?? ""),
      }),
      meta: { title: "四川手机报" },
    },
    {
      path: "*",
      name: "notFound",
      component: NotFound,
      meta: { title: "页面未找到 - 四川手机报" },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;

// server {
//   listen       8888;#默认端口是80，如果端口没被占用可以不用修改
//   server_name  localhost;
//   root        E:/vue/my_project/dist;#vue项目的打包后的dist
//   location / {
//     try_files $uri $uri/ @router;#需要指向下面的@router否则会出现vue的路由在nginx中刷新出现404
//   index  index.html index.htm;
// }
//   #对应上面的@router，主要原因是路由的路径资源并不是一个真实的路径，所以无法找到具体的文件
//   #因此需要rewrite到index.html中，然后交给路由在处理请求资源
//   location @router {
//     rewrite ^.*$ /index.html last;
//   }
//
// }
